import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../../data.service';
import{ UrlConstant } from '../../constants/url-constant';
import{ AppData } from '../../constants/app-data';

import { MatSnackBar } from "@angular/material/snack-bar";
import { NotificationService } from "../../services/notification.service";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
	records: Array<any>;
	
  constructor(private router: Router, private dataService: DataService, private appData: AppData,
    public notificationService: NotificationService,
    private _snackBar: MatSnackBar) { 
  	//console.log('DashboardComponent constructor');
  }
  
  ngOnInit(): void {
  	//console.log('DashboardComponent ngOnInit');
  }
  


}
